import {
    companyLegalTypeList,
    validatePhoneNumber,
  } from 'utils';

export const formFields2_1 = [
  
    {
      id: 'companyName',
      label: 'Επωνυμία Επιχείρησης',
      type: 'text',
      name: 'companyName',
      size: 'large',
      placeholder: 'Εισάγετε Επωνυμία Επιχείρησης',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
      asterisk: true,
    },
    {
      id:'abiVat',
      label: 'Α.Φ.Μ. Εταιρείας',
      type: 'text',
      name: 'abiVat',
      size: 'large',
      placeholder: 'Εισάγετε Α.Φ.Μ. Εταιρείας',
      span: 12,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        /*() => ({
          validator(_, value) {
            return validateAFM(value);
          },
        }),*/
      ],
      disabled: true,
    },
    {
      id: 'regDate',
      label: 'Ημ. Σύστασης',
      type: 'text',
      name: 'regDate',
      size: 'large',
      placeholder: 'Εισάγετε Ημ. Σύστασης',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      ],
      asterisk: true,
      disabled: true,
  },
    {
      id: 'mainKAD',
      label: 'ΚΑΔ Κύριας Δραστηριότητας',
      type: 'text',
      name: 'mainKAD',
      size: 'large',
      placeholder: 'Εισάγετε ΚΑΔ Κύριας Δραστηριότητας',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
      asterisk: true,
    },
    // {
    //   id: 'companyLegalType',
    //   label: 'Νομική Μορφή',
    //   title: 'Νομική Μορφή',
    //   type: 'text',
    //   name: 'companyLegalType',
    //   size: 'large',
    //   placeholder: 'Εισάγετε Νομική Μορφή',
    //   span: 24,
    //   asterisk: true,
    //   maxLength: 30, 
    //   rules: [
    //     { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //     {
    //       max: 30,
    //       message: 'Μέγιστος αριθμός χαρακτήρων: 30',
    //     },
    //   ],
    // },
    {
      label: 'Νομική Μορφή',
      title: 'Νομική Μορφή',
      type: 'select',
      // className: 'like-text',
      name: 'companyLegalType',
      size: 'large',
      options: companyLegalTypeList,
      placeholder: 'Επιλέξτε Νομική Μορφή',
      span: 24,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    // {
    //   id: 'companySize',
    //   label: 'Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ',
    //   type: 'radio',
    //   name: 'companySize',
    //   size: 44,
    //   options: [
    //     { label: 'Μικρή', value: 'Μικρή' },
    //     { label: 'Μεσαία', value: 'Μεσαία' },
    //     { label: 'Μεγάλη', value: 'Μεγάλη' },
    //   ],
    //   placeholder: '-',
    //   span: 24,
    //   asterisk: true,
    //   infoMessage:
    //   <span className='iban-info-title'> <b>Μικρή Επιχείρηση: </b> Λιγότεροι από 50 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών και/ή Ισολογισμός {'<='} 10.000.000,00€<br/>
    //   <b>Μεσαία Επιχείρηση: </b> Λιγότεροι από 250 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών {'<='}50.000.000,00€ και/ή Ετήσιος Ισολογισμός {'<='} 43.000.000,00€<br/>
    //   <b>Μεγάλη Επιχείρηση:</b> Περισσότεροι από 250 Εργαζόμενοι ή Ετήσιος Κύκλος Εργασιών {'>'} 50.000.000€ και Ετήσιος Ισολογισμός {'>'} 43.000.000,00€<br/></span>,
    //   infoMessageClassName: 'multiline-info-message',
    //   iconClassName: 'mt-1',
    //   rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    // },
  ];

  export const formFields2_2 = [
    {
      id: 'abiStreetFull',
      label: 'Οδός - Αριθμός',
      type: 'text',
      name: 'abiStreetFull',
      size: 'large',
      placeholder: 'Εισάγετε Οδό - Αριθμό',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      disabled: true,
    },
    {
      id: 'abiTk',
      label: 'Τ.Κ.',
      type: 'select',
      name: 'abiTk',
      size: 'small',
      placeholder: 'Εισάγετε Τ.Κ.',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      // disabled: false,
    },
    { 
      id: 'abiPerfecture',
      label: 'Νομός',
      title: 'Νομός',
      type: 'select',
      name: 'abiPerfecture',
      size: 'small',
      placeholder: 'Επιλέξτε Νομό',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'abiDistrict',
      label: 'Περιοχή',
      title: 'Περιοχή',
      type: 'select',
      name: 'abiDistrict',
      size: 'small',
      placeholder: 'Επιλέξτε Περιοχή',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'invMob',
      label: 'Τηλέφωνο',
      type: 'text',
      name: 'invMob',
      size: 'large',
      maxLength: 10,
      asterisk: true,
      placeholder: 'Εισάγετε Τηλέφωνο',
      span: 24,
      rules: [
        () => ({
          validator(_, value) {
            return validatePhoneNumber(value);
          },
        }),
      ],
    },
    // {
    //   id: 'website',
    //   label: 'Ιστοχώρος',
    //   // prefix: 'http://',
    //   type: 'text',
    //   name: 'website',
    //   size: 'large',
    //   placeholder: 'Εισάγετε Ιστοχώρο',
    //   span: 24,
    //   rules: [
    //     () => ({
    //       validator(_, value) {
    //         return validateWebSite(value);
    //       },
    //     }),
    //   ],
    // },
    {
      id: 'invMail',
      label: 'E-mail',
      type: 'text',
      name: 'invMail',
      size: 'large',
      placeholder: 'Εισάγετε E-mail',
      maxLength:50,
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { type: 'email', message: 'Αυτό που εισάγετε δεν είναι έγκυρη διεύθυνση e-mail'}
      ],
    },
  ];

